import React from 'react';
import { MailIcon, InstagramIcon, ShieldCheckIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-navy-deep text-white" data-id="element-71" data-mp="3ggaqtvj9sd5g">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "17px",
      paddingBottom: "23px"
    }} data-id="element-72" data-mp="32o48c2sn9u2u">
        <p className="flex items-center justify-center gap-2 font-display text-base font-black sm:text-lg" data-id="element-73" data-mp="36qhgsyys063b">
          <ShieldCheckIcon className="h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-74" data-mp="3ugbshd7czolz" />
          SIGMA SMART™ — THE REALTOR AI PLAYBOOK™
        </p>
        <p className="mx-auto mt-3 max-w-lg text-sm text-white/60" data-id="element-75" data-mp="36d08okdmdj3">
          Build smarter workflows. Use AI more strategically. Spend less time starting from scratch.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/75" data-id="element-76" data-mp="3qfjj8jyhljpp">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-77" data-mp="2a1jkhcbdo041">
            <MailIcon className="h-4 w-4 text-cyan" aria-hidden="true" data-id="element-78" data-mp="3labrlvxno6qd" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-79" data-mp="3gca6z6kkzzcs">
            <InstagramIcon className="h-4 w-4 text-cyan" aria-hidden="true" data-id="element-80" data-mp="3v5dgqrrxl8sy" /> @sigmasmart.en
          </a>
        </div>

        <nav aria-label="Legal" className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/55" data-id="element-81" data-mp="82qthw25bzvb">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-82" data-mp="34p8v6p2nshq">Terms & Conditions</a>
          <span aria-hidden="true" data-id="element-83" data-mp="hriflnkizpyb">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-84" data-mp="huo3x0lbynsz">Privacy Policy</a>
          <span aria-hidden="true" data-id="element-85" data-mp="qthyklf3p43w">·</span>
          <a href="mailto:soporte.sigmasmart@gmail.com" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-86" data-mp="quji7ea6myx8">Support</a>
        </nav>

        <p className="mt-8 text-xs text-white/45" data-id="element-87" data-mp="tv4lvxtlew2w">© 2026 SIGMA SMART™ — All rights reserved.</p>
      </div>
    </footer>;
}